module.exports = {
	"ha": "iha",
	"id": 5.5,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2018 Q1",
		"lastYear": "2018",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 90,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Interior Health by Age Category and MSM Status, Year Ending 2018 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "50%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "50%",
				"height": "50%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -100,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#043f61"
					},
					{
						"y": 90.9090909090909,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#0c4250"
					},
					{
						"y": 90.9090909090909,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#0d4440"
					},
					{
						"y": 90.9090909090909,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#09472e"
					},
					{
						"y": 81.81818181818183,
						"dataLabels": {
							"enabled": false,
							"format": "9"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 90.9090909090909,
						"dataLabels": {
							"enabled": false,
							"format": "20"
						},
						"color": "#043f61"
					},
					{
						"y": 77.27272727272727,
						"dataLabels": {
							"enabled": false,
							"format": "17"
						},
						"color": "#0c4250"
					},
					{
						"y": 68.18181818181817,
						"dataLabels": {
							"enabled": false,
							"format": "15"
						},
						"color": "#0d4440"
					},
					{
						"y": 63.63636363636363,
						"dataLabels": {
							"enabled": false,
							"format": "14"
						},
						"color": "#09472e"
					},
					{
						"y": 54.54545454545454,
						"dataLabels": {
							"enabled": false,
							"format": "12"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "30"
						},
						"color": "#043f61"
					},
					{
						"y": 93.33333333333333,
						"dataLabels": {
							"enabled": false,
							"format": "28"
						},
						"color": "#0c4250"
					},
					{
						"y": 86.66666666666667,
						"dataLabels": {
							"enabled": false,
							"format": "26"
						},
						"color": "#0d4440"
					},
					{
						"y": 86.66666666666667,
						"dataLabels": {
							"enabled": false,
							"format": "26"
						},
						"color": "#09472e"
					},
					{
						"y": 70,
						"dataLabels": {
							"enabled": false,
							"format": "21"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.24812030075188,
						"dataLabels": {
							"enabled": false,
							"format": "132"
						},
						"color": "#043f61"
					},
					{
						"y": 87.96992481203007,
						"dataLabels": {
							"enabled": false,
							"format": "117"
						},
						"color": "#0c4250"
					},
					{
						"y": 83.45864661654136,
						"dataLabels": {
							"enabled": false,
							"format": "111"
						},
						"color": "#0d4440"
					},
					{
						"y": 81.203007518797,
						"dataLabels": {
							"enabled": false,
							"format": "108"
						},
						"color": "#09472e"
					},
					{
						"y": 61.65413533834586,
						"dataLabels": {
							"enabled": false,
							"format": "82"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#043f61"
					},
					{
						"y": 60,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#0c4250"
					},
					{
						"y": 40,
						"dataLabels": {
							"enabled": false,
							"format": "2"
						},
						"color": "#0d4440"
					},
					{
						"y": 20,
						"dataLabels": {
							"enabled": false,
							"format": "1"
						},
						"color": "#09472e"
					},
					{
						"y": 20,
						"dataLabels": {
							"enabled": false,
							"format": "1"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "23"
						},
						"color": "#043f61"
					},
					{
						"y": 91.30434782608695,
						"dataLabels": {
							"enabled": false,
							"format": "21"
						},
						"color": "#0c4250"
					},
					{
						"y": 82.6086956521739,
						"dataLabels": {
							"enabled": false,
							"format": "19"
						},
						"color": "#0d4440"
					},
					{
						"y": 78.26086956521739,
						"dataLabels": {
							"enabled": false,
							"format": "18"
						},
						"color": "#09472e"
					},
					{
						"y": 56.52173913043478,
						"dataLabels": {
							"enabled": false,
							"format": "13"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "44"
						},
						"color": "#043f61"
					},
					{
						"y": 75,
						"dataLabels": {
							"enabled": false,
							"format": "33"
						},
						"color": "#0c4250"
					},
					{
						"y": 70.45454545454545,
						"dataLabels": {
							"enabled": false,
							"format": "31"
						},
						"color": "#0d4440"
					},
					{
						"y": 65.9090909090909,
						"dataLabels": {
							"enabled": false,
							"format": "29"
						},
						"color": "#09472e"
					},
					{
						"y": 36.36363636363637,
						"dataLabels": {
							"enabled": false,
							"format": "16"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "163"
						},
						"color": "#043f61"
					},
					{
						"y": 84.66257668711657,
						"dataLabels": {
							"enabled": false,
							"format": "138"
						},
						"color": "#0c4250"
					},
					{
						"y": 80.98159509202453,
						"dataLabels": {
							"enabled": false,
							"format": "132"
						},
						"color": "#0d4440"
					},
					{
						"y": 74.84662576687117,
						"dataLabels": {
							"enabled": false,
							"format": "122"
						},
						"color": "#09472e"
					},
					{
						"y": 57.05521472392638,
						"dataLabels": {
							"enabled": false,
							"format": "93"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 75,
						"dataLabels": {
							"enabled": false,
							"format": "12"
						},
						"color": "#043f61"
					},
					{
						"y": 56.25,
						"dataLabels": {
							"enabled": false,
							"format": "9"
						},
						"color": "#0c4250"
					},
					{
						"y": 56.25,
						"dataLabels": {
							"enabled": false,
							"format": "9"
						},
						"color": "#0d4440"
					},
					{
						"y": 56.25,
						"dataLabels": {
							"enabled": false,
							"format": "9"
						},
						"color": "#09472e"
					},
					{
						"y": 37.5,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 92,
						"dataLabels": {
							"enabled": false,
							"format": "23"
						},
						"color": "#043f61"
					},
					{
						"y": 68,
						"dataLabels": {
							"enabled": false,
							"format": "17"
						},
						"color": "#0c4250"
					},
					{
						"y": 64,
						"dataLabels": {
							"enabled": false,
							"format": "16"
						},
						"color": "#0d4440"
					},
					{
						"y": 52,
						"dataLabels": {
							"enabled": false,
							"format": "13"
						},
						"color": "#09472e"
					},
					{
						"y": 36,
						"dataLabels": {
							"enabled": false,
							"format": "9"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "56"
						},
						"color": "#043f61"
					},
					{
						"y": 66.07142857142857,
						"dataLabels": {
							"enabled": false,
							"format": "37"
						},
						"color": "#0c4250"
					},
					{
						"y": 57.14285714285714,
						"dataLabels": {
							"enabled": false,
							"format": "32"
						},
						"color": "#0d4440"
					},
					{
						"y": 53.57142857142857,
						"dataLabels": {
							"enabled": false,
							"format": "30"
						},
						"color": "#09472e"
					},
					{
						"y": 41.07142857142857,
						"dataLabels": {
							"enabled": false,
							"format": "23"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.52173913043478,
						"dataLabels": {
							"enabled": false,
							"format": "111"
						},
						"color": "#043f61"
					},
					{
						"y": 73.91304347826086,
						"dataLabels": {
							"enabled": false,
							"format": "85"
						},
						"color": "#0c4250"
					},
					{
						"y": 70.43478260869566,
						"dataLabels": {
							"enabled": false,
							"format": "81"
						},
						"color": "#0d4440"
					},
					{
						"y": 67.82608695652173,
						"dataLabels": {
							"enabled": false,
							"format": "78"
						},
						"color": "#09472e"
					},
					{
						"y": 48.69565217391305,
						"dataLabels": {
							"enabled": false,
							"format": "56"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.090909090909093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.999999999999998,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -9.090909090909093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.000000000000002,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.764705882352944,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.666666666666665,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.28571428571429,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.666666666666665,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.14285714285714,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.23076923076923,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.7518796992481258,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.363636363636365,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.128205128205132,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.7027027027026973,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -24.07407407407407,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -40,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -33.333333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -50,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.695652173913048,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.523809523809524,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.263157894736848,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.77777777777778,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.060606060606055,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.451612903225811,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -44.827586206896555,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.337423312883436,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.347826086956519,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.57575757575758,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.77049180327869,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -33.333333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -7.9999999999999964,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -26.086956521739136,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.882352941176472,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.75,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -30.76923076923077,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -33.92857142857143,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.513513513513509,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.33333333333333,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.4782608695652195,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.42342342342343,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.705882352941182,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.703703703703709,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -28.205128205128204,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=11"
			},
			{
				"x": 9,
				"text": "30-39<br>n=22"
			},
			{
				"x": 15,
				"text": "40-49<br>n=30"
			},
			{
				"x": 21,
				"text": ">=50<br>n=133"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=5"
			},
			{
				"x": 34,
				"text": "30-39<br>n=23"
			},
			{
				"x": 40,
				"text": "40-49<br>n=44"
			},
			{
				"x": 46,
				"text": ">=50<br>n=163"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=16"
			},
			{
				"x": 59,
				"text": "30-39<br>n=25"
			},
			{
				"x": 65,
				"text": "40-49<br>n=56"
			},
			{
				"x": 71,
				"text": ">=50<br>n=115"
			}
		],
		"dataTable": {
			"MSM:<30": [
				11,
				11,
				10,
				10,
				10,
				9
			],
			"MSM:30-39": [
				22,
				20,
				17,
				15,
				14,
				12
			],
			"MSM:40-49": [
				30,
				30,
				28,
				26,
				26,
				21
			],
			"MSM:>=50": [
				133,
				132,
				117,
				111,
				108,
				82
			],
			"Non-MSM:<30": [
				5,
				5,
				3,
				2,
				1,
				1
			],
			"Non-MSM:30-39": [
				23,
				23,
				21,
				19,
				18,
				13
			],
			"Non-MSM:40-49": [
				44,
				44,
				33,
				31,
				29,
				16
			],
			"Non-MSM:>=50": [
				163,
				163,
				138,
				132,
				122,
				93
			],
			"Unknown:<30": [
				16,
				12,
				9,
				9,
				9,
				6
			],
			"Unknown:30-39": [
				25,
				23,
				17,
				16,
				13,
				9
			],
			"Unknown:40-49": [
				56,
				56,
				37,
				32,
				30,
				23
			],
			"Unknown:>=50": [
				115,
				111,
				85,
				81,
				78,
				56
			]
		}
	},
	"callback": "C:\\Users\\Rafael\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_iha_5_5.json
// module id = 234
// module chunks = 0